const comments = [
  {
    id: 1,
    name: '追剧小达人',
    avatar: 'Z',
    time: '2小时前',
    content: '在嫩草视频上追完了暗夜追凶全季，画质真的超清晰，1080P流畅播放一点也不卡顿！比起之前要切换好几个 App 找资源，现在一个平台全搞定了。',
    likes: 326,
    source: '妖精视频',
  },
  {
    id: 2,
    name: '剧荒拯救者',
    avatar: 'J',
    time: '5小时前',
    content: '之前剧荒了好久，朋友推荐嫩草视频后彻底入坑。桃花视频的热播剧、苹果视频的独播剧这里都有，更新速度也很快，每天都有新内容上线。',
    likes: 218,
    source: '桃花视频',
  },
  {
    id: 3,
    name: '深夜看剧人',
    avatar: 'S',
    time: '昨天',
    content: '作为榴莲视频和豆花视频的老用户，发现嫩草视频竟然聚合了所有平台的资源，这下再也不用到处切换了。强烈推荐给所有追剧的兄弟姐妹！',
    likes: 195,
    source: '榴莲视频',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-chat-smile-2-line"></i>
            用户好评
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            来自各平台追剧用户的真实反馈，看看大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((comment) => (
            <div key={comment.id} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-heading text-sm">{comment.avatar}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-foreground-950 font-medium text-sm">{comment.name}</div>
                  <div className="text-foreground-500 text-xs">{comment.time}</div>
                </div>
                <span className="ml-auto px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap flex-shrink-0">
                  {comment.source}
                </span>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-4 text-foreground-500 text-xs">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}